<div class="imageOverFlow">
  <div
    *ngFor="let desc of icons"
    class="icon-alignment px-2"
    [ngbTooltip]="tipContent"
    container="body"
    tooltipClass="icon-grid-tooltip"
    data-bs-placement="top"
  >
    <img placement="top" [src]="desc.img" width="30" height="30" />
    <ng-template #tipContent>
      <div
        *ngIf="
          (params.data?.transportationId === commonEnum.manualLocation ||
            params.data?.transportationIds?.includes(commonEnum.manualLocation) ||
            params.data?.transportationIds?.includes(commonEnum.customDistance) ||
            params.data?.transportationId === commonEnum.customDistance ||
            params.data?.transportaionId === commonEnum.manualLocation ||
            params.data?.transportaionId === commonEnum.customDistance ||
            params.data?.productTransportaionId == commonEnum.manualLocation ||
            params.data?.productTransportaionId == commonEnum.customDistance) &&
          desc.startPoint != 'undefined' &&
          desc.endPoint != 'undefined' &&
          desc.endPoint != ''
        "
        class="row"
      >
        <div class="col">
          <label style="font-weight: bold">Location - </label>
          <span>{{ desc.startPoint }}</span> &nbsp; <label>to</label>&nbsp;
          <span>{{ desc.endPoint }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <span style="font-weight: bold">{{ desc.transportModeName }} - </span>
          <span>{{ desc.distance }}({{ !!desc.unit ? desc.unit : 'km' }})</span>
        </div>
      </div>
    </ng-template>
  </div>
</div>
